import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';
import { Button } from 'src/components/atoms/Button';

type ModelHeaderProps = {
  modelIndex: number;
  modelsLength: number;
  onRemove?: () => void;
  canRemove?: boolean;
};

export const ModelHeader: React.FC<ModelHeaderProps> = ({
  modelIndex,
  modelsLength,
  onRemove,
  canRemove = true,
}) => {
  if (modelsLength <= 1) {
    return null;
  }

  return (
    <Flex justify="space-between" align="center" mb={2}>
      <Text fontSize="18px" fontWeight={600} color="text.title">
        Model {modelIndex + 1}
      </Text>
      {canRemove && onRemove && (
        <Button
          buttonName="Remove model"
          leftIcon={<Icon iconName="trash" />}
          variant="ghost"
          color="red.500"
          bg="transparent"
          borderRadius="md"
          size="sm"
          fontSize="14px"
          fontWeight={500}
          onClick={onRemove}
          _hover={{
            bg: 'red.50',
            color: 'red.600',
          }}
          _active={{
            bg: 'red.100',
            color: 'red.700',
          }}>
          Remove
        </Button>
      )}
    </Flex>
  );
};
